import './mainslider.css';
// import IMAGES from "../../images/images";
import { Swiper, SwiperSlide } from 'swiper/react';
import { archiSlider } from '../../data';
import 'swiper/swiper-bundle.min.css';
import 'swiper/swiper.min.css';
import SwiperCore, {
    Zoom,Navigation,Pagination,Keyboard, Autoplay, EffectFade 
  } from 'swiper';

SwiperCore.use([Zoom,Navigation,Pagination,Keyboard,Autoplay,EffectFade]);


export default function MainSlider( ) {
    return (
        <div className="archi__main">
            <h1 className="archi__title">Architecture</h1>
            
            <Swiper
                spaceBetween={0} 
                effect={'fade'} 
                navigation={true} 
                pagination={{ "clickable": true}}
                autoplay={{"delay": 3000}}
                className="archi__imageSliderWrapper"
                zoom={true}
                >
                
                    {archiSlider.map((d)=> (
                <SwiperSlide className="imageSlider">
                    <div class="swiper-zoom-container">
                        <img src={d.img} alt="" />
                    </div>
                        <h3>Creek-View Estate</h3>
                </SwiperSlide>

                    ))}
                    
            </Swiper>

        </div>
    )
}
